<!-- =========================================================================================
    File Name: TableDefault.vue
    Description: Rendering default table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-popup :title="$t('Warning')" :active.sync="popupActive">
      <div class="flex flex-wrap">
        <div class="w-full p-2">
          <p class="mb-3">
            Atenção! Ao criar uma campanha de WhatsApp, você concorda que pode
            haver custos extras na sua mensalidade Duotalk, de acordo com o
            volume de disparos e seu plano contratado.
          </p>
        </div>
        <div class="w-full">
          <vs-button
            size="medium"
            @click="$router.push('/apps/campaigns/new').catch(() => {})"
            >{{ $t("Accept") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      :title="$t('History')"
      :active.sync="popupCampaignActive"
      fullscreen
    >
      <div class="flex flex-wrap">
        <div class="w-full p-2">
          <div class="flex w-full">
            <p class="mb-3">Disparos da campanha</p>
            <div class="right-0 absolute hidden md:block">
              <vs-button
                icon-pack="feather"
                icon="icon-file"
                size="small"
                class="mr-12"
                @click="downloadCSV()"
                >{{ $t("DownloadXLSX") }}</vs-button
              >
            </div>
          </div>
          <div class="w-full">
            <table class="fl-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{{ $t("Name") }}</th>
                  <th>{{ $t("Phone") }}</th>
                  <th>{{ $t("Status") }}</th>
                  <th></th>
                  <th></th>
                  <th>{{ $t("Answer") }}</th>
                  <th>{{ $t("Date") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="indextr" v-for="(data, indextr) in campaignDetails">
                  <td>
                    {{ indextr + 1 }}
                  </td>
                  <td>
                    {{ data.name }}
                  </td>
                  <td>
                    {{ data.phone }}
                  </td>
                  <td>
                    {{ getStatusString(data.executeStatus, data.executed) }}
                  </td>
                  <td class="place-content-center">
                    <vs-chip
                      color="success"
                      v-if="data.executionSuccess"
                      class="place-self-center"
                    >
                      {{ $t("Success") }}
                    </vs-chip>
                    <vs-chip
                      color="danger"
                      v-else-if="data.executionSuccess === false"
                      class="place-self-center"
                    >
                      {{ $t("Error") }}
                    </vs-chip>
                  </td>

                  <td style="max-width: 100px" class="truncate">
                    <span :title="data.executionErrorMessage">
                      {{ data.executionErrorMessage }}
                    </span>
                  </td>
                  <td style="max-width: 100px" class="truncate">
                    <span>
                      {{ data.answered ? $t("Yes") : $t("No")}}
                    </span>
                  </td>
                  <td>
                    <span v-if="data.executed">
                      {{ new Date(data.updatedAt).toLocaleDateString() }}
                      {{ $t("atTime") }}
                      {{ new Date(data.updatedAt).toLocaleTimeString() }}
                    </span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </vs-popup>
    <h3 class="mb-5 mt-10">
      {{ $t("Campaigns") }}
    </h3>
    <vs-tabs position="left">
      <vs-tab
        label="Disparos"
        icon-pack="feather"
        icon="icon-send"
        class="pt-0"
      >
        <vs-card class="p-3 shadow-none">
          <vs-row>
            <vs-col>
              <vs-button
                class="mr-5"
                @click="popupActive = true"
                icon-pack="feather"
                icon="icon-plus"
                icon-after
              >
                {{ $t("NewCampaign") }}
              </vs-button>
            </vs-col>
            <vs-col class="mt-5">
              <vs-table
                :max-items="limit"
                stripe
                :data="manualSending.campaigns"
              >
                <template slot="thead">
                  <vs-th>{{ $t("CampaignName") }}</vs-th>
                  <vs-th>{{ $t("CampaignDescription") }}</vs-th>
                  <vs-th>{{ $t("User") }}</vs-th>
                  <vs-th>{{ $t("Date") }}</vs-th>
                  <vs-th>{{ $t("Status") }}</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <div class="w-full">
                        {{ data[indextr].name }}
                      </div>
                      <div class="w-full text-xs">
                        <span v-if="data[indextr].templateName">
                          {{ $t("Template") }}:
                          {{ data[indextr].templateName }} <br />
                        </span>
                        <span v-if="data[indextr].intention">
                          {{ $t("Intention") }}: {{ data[indextr].intention }}
                          <br />
                        </span>
                        <span v-if="data[indextr].entity">
                          {{ $t("EntityKey") }}: {{ data[indextr].entity }}
                          <br />
                        </span>
                        <span>
                          {{ $t("OpenedConversations") }}:
                          {{
                            data[indextr].sendToOpenConversations
                              ? $t("Yes")
                              : $t("No")
                          }}
                          <br />
                        </span>
                      </div>
                    </vs-td>
                    <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                    </vs-td>

                    <vs-td :data="data[indextr].userName">
                      {{ data[indextr].userName }}
                    </vs-td>
                    <vs-td :data="data[indextr].createdAt">
                      <template v-if="!data[indextr].scheduleDate">
                        {{
                          new Date(data[indextr].createdAt).toLocaleDateString()
                        }}
                        {{ $t("atTime") }}
                        {{
                          new Date(data[indextr].createdAt).toLocaleTimeString()
                        }}
                      </template>
                      <template v-else-if="data[indextr].status < 3">
                        <div
                          v-if="
                            new Date() <= new Date(data[indextr].scheduleDate)
                          "
                          class="flex items-center text-primary"
                        >
                          <feather-icon
                            svgClasses="h-4 w-4 mr-2"
                            icon="ClockIcon"
                          />
                          Agendado para<br />
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleDateString()
                          }}
                          {{ $t("atTime") }}
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleTimeString()
                          }}
                        </div>
                        <div v-else class="flex items-center">
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleDateString()
                          }}
                          {{ $t("atTime") }}
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleTimeString()
                          }}
                        </div>
                      </template>
                      <template v-else-if="data[indextr].status === 3">
                        {{
                          new Date(
                            data[indextr].scheduleDate
                          ).toLocaleDateString()
                        }}
                        {{ $t("atTime") }}
                        {{
                          new Date(
                            data[indextr].scheduleDate
                          ).toLocaleTimeString()
                        }}
                      </template>
                      <template v-else-if="data[indextr].status > 3">
                        <div class="flex items-center text-danger">
                          <feather-icon
                            svgClasses="h-4 w-4 mr-2"
                            icon="XCircleIcon"
                          />
                          Envio cancelado
                        </div>
                      </template>
                    </vs-td>
                    <vs-td :data="data[indextr].totalContacts">
                      <div class="flex gap-x-3">
                        <vs-chip color="primary">
                          {{ $t("Total") }}: {{ data[indextr].totalContacts }}
                        </vs-chip>
                        <vs-chip color="success">
                          {{ $t("Success") }}:
                          {{ `${data[indextr].totalSuccess || 0} (${getPercent(data[indextr].totalSuccess, data[indextr].totalContacts)})` }}
                        </vs-chip>
                        <vs-chip color="grey">
                          {{ $t("Error") }}:
                          {{ `${data[indextr].totalErrors || 0} (${getPercent(data[indextr].totalErrors, data[indextr].totalContacts)})` }}
                        </vs-chip>
                        <vs-chip color="grey">
                          {{ $t("Answers") }}:
                          {{ `${data[indextr].totalAnswers || 0} (${getPercent(data[indextr].totalAnswers, data[indextr].totalSuccess)}) `}}
                        </vs-chip>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div
                        class="flex"
                        :class="
                          data[indextr].status < 3 &&
                          data[indextr].scheduleDate !== null
                            ? 'justify-around'
                            : 'justify-center'
                        "
                      >
                        <vs-button
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-search"
                          radius
                          @click="getCampaignInfo(data[indextr]._id)"
                        />
                        <vs-tooltip 
                          text="Cancelar envio" 
                          color="danger" 
                          v-if="
                            data[indextr].status < 3 &&
                            data[indextr].scheduleDate !== null &&
                            new Date() <= new Date(data[indextr].scheduleDate)
                          "
                        >
                          <vs-button
                            color="danger"
                            type="border"
                            icon-pack="feather"
                            icon="icon-x"
                            radius
                            @click="openPopupCancelSchedule(data[indextr])"
                          />
                        </vs-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination
                class="mt-4"
                :total="manualSending.pages"
                v-model="manualSendingPage"
              />
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-tab>
      <vs-tab
        label="Automações"
        icon-pack="feather"
        icon="icon-link"
        class="pt-0"
      >
        <vs-card class="p-3 shadow-none">
          <vs-row>
            <vs-col>
              <vs-button
                class="mr-5"
                @click="popupActive = true"
                icon-pack="feather"
                icon="icon-plus"
                icon-after
              >
                {{ $t("NewCampaign") }}
              </vs-button>
            </vs-col>
            <vs-col class="mt-5">
              <vs-table
                :max-items="limit"
                stripe
                :data="automationSending.campaigns"
              >
                <template slot="thead">
                  <vs-th>{{ $t("CampaignName") }}</vs-th>
                  <vs-th>{{ $t("CampaignDescription") }}</vs-th>
                  <vs-th>{{ $t("User") }}</vs-th>
                  <vs-th>{{ $t("Date") }}</vs-th>
                  <vs-th>{{ $t("Status") }}</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <div class="w-full">
                        {{ data[indextr].name }}
                      </div>
                      <div class="w-full text-xs">
                        <span v-if="data[indextr].templateName">
                          {{ $t("Template") }}:
                          {{ data[indextr].templateName }} <br />
                        </span>
                        <span v-if="data[indextr].intention">
                          {{ $t("Intention") }}: {{ data[indextr].intention }}
                          <br />
                        </span>
                        <span v-if="data[indextr].entity">
                          {{ $t("EntityKey") }}: {{ data[indextr].entity }}
                          <br />
                        </span>
                        <span>
                          {{ $t("OpenedConversations") }}:
                          {{
                            data[indextr].sendToOpenConversations
                              ? $t("Yes")
                              : $t("No")
                          }}
                          <br />
                        </span>
                      </div>
                    </vs-td>
                    <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                    </vs-td>

                    <vs-td :data="data[indextr].userName">
                      {{ data[indextr].userName }}
                    </vs-td>
                    <vs-td :data="data[indextr].createdAt">
                      <template v-if="!data[indextr].scheduleDate">
                        {{
                          new Date(data[indextr].createdAt).toLocaleDateString()
                        }}
                        {{ $t("atTime") }}
                        {{
                          new Date(data[indextr].createdAt).toLocaleTimeString()
                        }}
                      </template>
                      <template v-else-if="data[indextr].status < 3">
                        <div class="flex items-center text-primary">
                          <feather-icon
                            svgClasses="h-4 w-4 mr-2"
                            icon="ClockIcon"
                          />
                          Agendado para<br />
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleDateString()
                          }}
                          {{ $t("atTime") }}
                          {{
                            new Date(
                              data[indextr].scheduleDate
                            ).toLocaleTimeString()
                          }}
                        </div>
                      </template>
                      <template v-else-if="data[indextr].status === 3">
                        {{
                          new Date(
                            data[indextr].scheduleDate
                          ).toLocaleDateString()
                        }}
                        {{ $t("atTime") }}
                        {{
                          new Date(
                            data[indextr].scheduleDate
                          ).toLocaleTimeString()
                        }}
                      </template>
                      <template v-else-if="data[indextr].status > 3">
                        <div class="flex items-center text-danger">
                          <feather-icon
                            svgClasses="h-4 w-4 mr-2"
                            icon="XCircleIcon"
                          />
                          Envio cancelado
                        </div>
                      </template>
                    </vs-td>
                    <vs-td :data="data[indextr].totalContacts">
                      <div class="flex gap-x-3">
                        <vs-chip color="success">
                          {{ $t("Success") }}:
                          {{ `${data[indextr].totalSuccess || 0} (${getPercent(data[indextr].totalSuccess, data[indextr].totalContacts)})` }}
                        </vs-chip>
                        <vs-chip color="grey">
                          {{ $t("Error") }}:
                          {{ `${data[indextr].totalErrors || 0} (${getPercent(data[indextr].totalErrors, data[indextr].totalContacts)})` }}
                        </vs-chip>
                        <vs-chip color="grey">
                          {{ $t("Answers") }}:
                          {{ `${data[indextr].totalAnswers || 0} (${getPercent(data[indextr].totalAnswers, data[indextr].totalSuccess)}) `}}
                        </vs-chip>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div
                        class="flex"
                        :class="
                          data[indextr].status < 3 &&
                          data[indextr].scheduleDate !== null
                            ? 'justify-around'
                            : 'justify-center'
                        "
                      >
                        <vs-button
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-search"
                          radius
                          @click="getCampaignInfo(data[indextr]._id)"
                        />
                        <vs-tooltip text="Cancelar envio" color="danger">
                          <vs-button
                            color="danger"
                            type="border"
                            icon-pack="feather"
                            icon="icon-x"
                            radius
                            v-if="
                              data[indextr].status < 3 &&
                              data[indextr].scheduleDate !== null &&
                              new Date() <= new Date(data[indextr].scheduleDate)
                            "
                            @click="openPopupCancelSchedule(data[indextr])"
                          />
                        </vs-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination
                class="mt-4"
                :total="automationSending.pages"
                v-model="automationSendingPage"
              />
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Cancelar agendamento" :active.sync="popupCancelSchedule">
      <vs-row>
        <vs-col>
          <p class="text-base">
            Ao optar pelo cancelamento, a campanha
            <b>{{
              campaignCancelSchedule ? campaignCancelSchedule.name : ""
            }}</b
            >,<br />
            agendada para
            <b>
              {{
                campaignCancelSchedule
                  ? new Date(
                      campaignCancelSchedule.scheduleDate
                    ).toLocaleDateString()
                  : ""
              }}
            </b>
            {{ $t("atTime") }}
            <b>
              {{
                campaignCancelSchedule
                  ? new Date(
                      campaignCancelSchedule.scheduleDate
                    ).toLocaleTimeString()
                  : ""
              }}
            </b>
            não será mais enviada.<br /><br />
            Confirmar cancelamento?
          </p>
        </vs-col>
        <vs-col class="mt-5">
          <vs-button
            color="danger"
            @click="handleCancelSchedule(campaignCancelSchedule._id)"
          >
            Cancelar agendamento
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import xlsx from "xlsx/dist/xlsx.full.min";

export default {
  data() {
    return {
      limit: 30,
      automationSendingPage: 1,
      manualSendingPage: 1,
      automationSending: {
        total: 0,
        campaigns: [],
        pages: 0,
      },
      manualSending: {
        total: 0,
        campaigns: [],
        pages: 0,
      },
      campaignDetails: [],
      popupActive: false,
      popupCampaignActive: false,
      popupCancelSchedule: false,
      campaignCancelSchedule: null,
    };
  },
  async mounted() {
    await this.manualList();
    await this.automationList();
  },
  methods: {
    getStatusString(val, executed) {
      if (executed) return this.$t("Finished");
      if (val === 1) return this.$t("Waiting");
      if (val === 2) return this.$t("Executing");
      if (val === 3) return this.$t("Paused");
      if (val === 4) return this.$t("Stopped");
      if (val === 5) return this.$t("Finished");
      return this.$t("Unknown");
    },
    getCampaignInfo(id) {
      this.$vs.loading();
      this.campaignDetails = [];
      this.$http
        .get(
          `/p/campaign/details/${id}?acc=${this.$store.state.acc.current_acc.id}`
        )
        .then(async (result) => {
          this.$vs.loading.close();
          this.campaignDetails = result.data.data;
          this.popupCampaignActive = true;
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: this.$t("UnexpectedError"),
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    downloadCSV() {
      this.$vs.loading();
      // journy track
      window.analytics.track(
        "Download Campanhas",
        {},
        { groupId: this.$store.state.acc.current_acc.id }
      );
      const XLSX = xlsx,
        workbook = XLSX.utils.book_new(),
        arrayXlsx = [];

      const headers = {
        name: "Nome",
        phone: "Telefone",
        executionSuccess: "Status da execução",
        executionErrorMessage: "Mensagem do status de execução",
        answered: "Resposta", 
        executed: "Status",
        updatedAt: "Data",
      };

      this.campaignDetails.forEach((object) => {
        const data = {};
        Object.entries(object).forEach((deepestValue) => {
          const [key, value] = deepestValue;
          if (key === "executed") {
            data[headers[key]] = this.getStatusString(
              object.executeStatus,
              object.executed
            );
          } else if (key === "updatedAt") {
            data[headers[key]] = `${new Date(
              value
            ).toLocaleDateString()} ${this.$t("atTime")} ${new Date(
              value
            ).toLocaleTimeString()}`;
          } else if (headers[key]) {
            data[headers[key]] = value === true ? "Sim" : value;
          }
        });
        arrayXlsx.push(data);
      });
      const worksheet = XLSX.utils.json_to_sheet(arrayXlsx);
      XLSX.utils.book_append_sheet(workbook, worksheet, "report");
      XLSX.writeFile(workbook, "campaigns-history.xlsx");
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    getPercent(value, total) {
      if (total === 0) return '0%'
      return `${((value || 0) / (total || 0) * 100).toFixed(2)}%`;
    },
    async manualList(page) {
      await this.$http
        .get(`/p/campaign/list`, {
          params: {
            acc: this.$store.state.acc.current_acc.id,
            page: page || 1,
            limit: this.limit,
            userName: "users",
          },
        })
        .then(async (result) => {
          this.manualSending = result.data.data;

          this.manualSendingPage = result.data.data.page;
        })
        .catch(() => {
          this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: this.$t("UnexpectedError"),
            iconPack: "feather",
            icon: "icon-x",
            color: "danger",
            position: "top-right",
          });
        });
    },
    async automationList(page) {
      await this.$http
        .get(`/p/campaign/list`, {
          params: {
            acc: this.$store.state.acc.current_acc.id,
            page: page || 1,
            limit: this.limit,
            userName: "system",
          },
        })
        .then(async (result) => {
          this.automationSending = result.data.data;
          this.automationSendingPage = result.data.data.page;
        })
        .catch(() => {
          this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: this.$t("UnexpectedError"),
            iconPack: "feather",
            icon: "icon-x",
            color: "danger",
            position: "top-right",
          });
        });
    },
    openPopupCancelSchedule(campaign) {
      this.popupCancelSchedule = true;
      this.campaignCancelSchedule = campaign;
    },
    async handleCancelSchedule(id) {
      const response = await this.$http.delete("/p/campaign/" + id, {
        params: {
          acc: this.$store.state.acc.current_acc.id,
        },
      });

      if (response.status === 200) {
        this.popupCancelSchedule = false;
        this.campaignCancelSchedule = false;

        this.automationSending.campaigns.forEach((el, i) => {
          if (el._id === id) this.automationSending.campaigns[i].status = 5;
        });

        this.manualSending.campaigns.forEach((el, i) => {
          if (el._id === id) this.manualSending.campaigns[i].status = 5;
        });

        this.$vs.notify({
          time: 2500,
          title: this.$t("Success"),
          text: "Agendamento cancelado com sucesso.",
          iconPack: "feather",
          icon: "icon-check",
          color: "success",
          position: "top-right",
        });
      } else {
        this.$vs.notify({
          time: 2500,
          title: this.$t("Error"),
          text: "Erro ao cancelar agendamento.",
          iconPack: "feather",
          icon: "icon-x",
          color: "danger",
          position: "top-right",
        });
      }
    },
  },
  watch: {
    async automationSendingPage() {
      await this.automationList(this.automationSendingPage);
    },
    async manualSendingPage() {
      await this.manualList(this.manualSendingPage);
    },
  },
};
</script>
<style scoped lang="scss">
.table-wrapper {
  margin: 10px 70px 70px;
  box-shadow: 0px 35px 50px rgba(0, 0, 0, 0.2);
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl-table td,
.fl-table th {
  text-align: center;
  padding: 8px;
}

.fl-table td {
  border-right: 1px solid #f8f8f8;
  font-size: 12px;
}

.fl-table thead th {
  color: #ffffff;
  background: #b8b8b8;
}

.fl-table tr:nth-child(even) {
  background: #f8f8f8;
}

/* Responsive */

@media (max-width: 767px) {
  .fl-table {
    display: block;
    width: 100%;
  }

  .table-wrapper:before {
    content: "Scroll horizontally >";
    display: block;
    text-align: right;
    font-size: 11px;
    color: white;
    padding: 0 0 10px;
  }

  .fl-table thead,
  .fl-table tbody,
  .fl-table thead th {
    display: block;
  }

  .fl-table thead th:last-child {
    border-bottom: none;
  }

  .fl-table thead {
    float: left;
  }

  .fl-table tbody {
    width: auto;
    position: relative;
    overflow-x: auto;
  }

  .fl-table td,
  .fl-table th {
    padding: 20px 0.625em 0.625em 0.625em;
    height: 60px;
    vertical-align: middle;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    width: 90px;
    font-size: 13px;
    text-overflow: ellipsis;
  }

  .fl-table thead th {
    text-align: left;
    border-bottom: 1px solid #f7f7f9;
  }

  .fl-table tbody tr {
    display: table-cell;
  }

  .fl-table tbody tr:nth-child(odd) {
    background: none;
  }

  .fl-table tr:nth-child(even) {
    background: transparent;
  }

  .fl-table tr td:nth-child(odd) {
    background: #f8f8f8;
    border-right: 1px solid #e6e4e4;
  }

  .fl-table tr td:nth-child(even) {
    border-right: 1px solid #e6e4e4;
  }

  .fl-table tbody td {
    display: block;
    text-align: center;
  }
}
</style>
